import $ from "jquery";
import { createNanoId, contentMeta, getDynData } from "#scripts/general_functions";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";
import { campaigns, campaignItem } from "#templates/modules/campaigns_template";

export const getCampaigns = (load, from, moduleCardItemGuid, callback) => {
	let campaignsContentId = "4e159a34-1e45-413f-b053-a2bd9f843121"; // Forsidekampanje
	if (window.serverdata.configMeta.aim.template !== "frontpage") {
		campaignsContentId = "09ceb3f2-3b86-4a5f-a823-16c6210982bc"; // Kampanje (generell)
	}

	let apiLang = "nb_no";

	switch (window.serverdata.configMeta.aim.lang) {
		case "nb":
		case "nn":
			apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
			break;
		case "en":
			apiLang = "en_us";
			break;
	}
	apiLang = localStorage.getItem("currentLanguage") || apiLang;

	const apiCall = `${window.apiUrl}/Public/articles`;
	const apiParametersArray = [];

	let ids = [];
	if (moduleCardItemGuid.includes(";")) {
		ids = moduleCardItemGuid.split(";");
	} else {
		ids.push(moduleCardItemGuid);
	}

	for (const id of ids) {
		if (id !== "") {
			apiParametersArray.push(
				`/${id}?subscriptionId=${window.serverdata.configMeta.aim.clientId}&language=${apiLang}&includeCategories=true&offset=${from}&limit=${load}&sortBy=Published&useSortIndex=true&getRecursiveContent=true&WrapAsList=true`,
			);
		} else {
			apiParametersArray.push(
				`?subscriptionId=${window.serverdata.configMeta.aim.clientId}&contentType=${campaignsContentId}&language=${apiLang}&includeCategories=true&offset=${from}&limit=${load}&sortBy=Published&useSortIndex=true&getRecursiveContent=true`,
			);
		}
	}

	Promise.all(apiParametersArray.map((apiParameters) => fetch(apiCall + apiParameters).then((response) => response.json())))
		.then((data) => {
			// Combine the listOfContent arrays from each response
			const combinedListOfContent = data.reduce((acc, current) => {
				return acc.concat(current.listOfContent);
			}, []);

			// Create the new JSON object
			const combinedData = {
				totalCount: combinedListOfContent.length,
				listOfContent: combinedListOfContent,
			};
			callback(combinedData);
		})
		.catch((error) => {
			// if there's an error, log it
			console.log(error);
		});
};

export const campaignsFront = (maxItems = 1, moduleCardItemGuid = null, campaignDesign = "", moduleCardColor = "") => {
	const moduleGuid = createNanoId();

	getCampaigns(maxItems, 0, moduleCardItemGuid, (data) => {
		const campaigns = [];
		let campCount = 0;

		if (data.totalCount > 0) {
			for (const campaign of data.listOfContent) {
				const meta = contentMeta(campaign);
				const details = meta !== undefined ? getDynData(meta) : "";
				const campGuid = createNanoId();
				const addThisItem = moduleCardItemGuid === "" || moduleCardItemGuid.includes(campaign.contentId);

				if (window.serverdata.configMeta.aim?.moduleSettings?.campaigns?.introNewline === true && (details.forsidetekst !== undefined || details.kampanjetekst !== undefined)) {
					details.forsidetekst = details.forsidetekst.replace(/\n/g, "<br>");
					details.kampanjetekst = details.kampanjetekst.replace(/\n/g, "<br>");
				}
				if (addThisItem && campCount < maxItems && (details.forsidetittel || details.kampanjetekst)) {
					let image = "";

					if (meta.imageContentId) {
						// hasImage = true;
						image = `<div class="campaign__image_container">
												<img src='' id='campaign_${campGuid}' class="campaign__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}">
										</div>`;
						getImageByContentId(meta.imageContentId, (img) => {
							$(`#campaign_${campGuid}`).attr({
								"data-src": img.url,
								src: "/images/transparent.png",
								"data-imagemode": "fill",
							});
							if (img.imageHotspotX !== undefined && img.imageHotspotY !== undefined) {
								$(`#campaign_${campGuid}`).attr({
									"data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
								});
							}
							setResponsiveImage($(`#campaign_${campGuid}`), window.screen.availWidth > 691 ? "16:9" : "1:1");
						});
					}

					let link = `/artikkel/${campaign.nameInUrl}`;
					// let linktext = 'Les mer her';
					// let dynLink = getDynData(meta, "ea427bbd-f370-4f63-9769-2120a6a6fefd").res;
					const dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res; // "Lenke fra forsideboks (valgfri)"
					const sortorder = details.sorteringsrekkefolge; // getDynData(meta, "sortorder").res;
					if (dynLink) {
						link = dynLink; // `<span class="campaign__link">Gå til siden</span>`;
						// linktext = language('CAMPAIGN_GOTOPAGE');
					}

					campCount++;
					campaigns.push({
						item: campaignItem({
							link,
							image,
							forsidetittel: details.forsidetittel || details.kampanjetittel || "",
							forsidetekst: details.forsidetekst || details.kampanjetekst || "",
							order: sortorder,
							color: moduleCardColor,
						}),
						order: sortorder,
					});
				}
			}
		}

		// if(sorting) {
		// campaigns.sort(function(a,b) => (a.))
		// }
		// const sortedCampaigns = campaigns.sort((a, b) => {
		//   if (a.order < b.order) return -1;
		//   if (a.order > b.order) return 1;
		//   return 0;
		// });

		// sortedCampaigns = sortedCampaigns.slice(0, maxItems);

		if (campaigns.length < 1) {
			$(`#campaigns_${moduleGuid}>div`).html("");
			$(`#campaigns_${moduleGuid}`).hide();
		} else {
			// campaigns = campaigns.join("");
			// $("#campaigns").html(campaigns.join(""));
			const joinedCampaigns = campaigns.map((e) => e.item).join("");
			$(`#campaigns_${moduleGuid}`).html(joinedCampaigns);
		}
		if (campaigns.length === 1) {
			$(`#campaigns_${moduleGuid}`).addClass("single");
		}
	});

	return campaigns({
		moduleID: moduleGuid,
		campaignDesign,
		maxItems,
	});
};
